export const upperCase = (str) => {
    if (typeof str !== 'string') {
        return '';
    }
    return str.toUpperCase();
}